<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>物种信息管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud :fields="fields" :select="select" :limits="limits" apiU="Species"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'fenceId',
						label: '栅栏',
						type: 'select',
						data: (value)=>{
							value.splice(0,value.length);
							this.api.Fence.getList()
							.then((response)=>{
								let val=response.data.data.list.map((v)=>{
									return {
										label: v.name,
										value: v.id.toString()
									}
								});
								value.push(...val);
							})
						},
						prop: {
							label: 'label',
							value: 'value'
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择栅栏', trigger: 'blur' }
						]
					},
					{
						name: 'speciesDetailsId',
						label: '物种详情',
						type: 'select',
						data: (value)=>{
							value.splice(0,value.length);
							this.api.Speciesdetails.getList()
							.then((response)=>{
								let val=response.data.data.list.map((v)=>{
									return {
										label: v.name,
										value: v.id.toString()
									}
								});
								value.push(...val);
							})
						},
						prop: {
							label: 'label',
							value: 'value'
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择物种详情', trigger: 'blur' }
						]
					},
					{
						name: 'alias',
						label: '别名',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入物种别名', trigger: 'blur' }
						]
					},
					{
						name: 'avatar',
						label: '图片',
						type: 'image',
						isphone: true,
						rule: [
							{ required: true, message: '请上传图片', trigger: 'blur' }
						]
					},
					{
						name: 'images',
						label: '更多图片',
						type: 'images',
						isphone: true,
						rule: []
					},
					{
						name: 'sex',
						label: '畜别',
						type: 'select',
						data: [
							{
								label: '公',
								value: 'male'
							},
							{
								label: '母',
								value: 'female'
							}
						],
						prop: {
							label: 'label',
							value: 'value'
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择畜别', trigger: 'blur' }
						]
					},
					{
						name: 'city',
						label: '地址',
						type: 'address',
						isphone: true,
						rule: []
					},
					{
						name: 'address',
						label: '详细地址',
						type: 'string',
						isphone: true,
						rule: []
					},
					{
						name: 'latLong',
						label: '经纬度',
						type: 'latlong',
						isphone: true,
						rule: []
					},
					{
						name: 'rank',
						label: '级别',
						type: 'string',
						isphone: true,
						rule: []
					},
					{
						name: 'price',
						label: '价值',
						type: 'num',
						isphone: true,
						rule: [
							{ required: true, message: '请输入价值(单位：元)', trigger: 'blur' },
							{ type: 'number', message: '价值必须为数字值(单位：元)'}
						]
					},
					{
						name: 'weight',
						label: '体重',
						type: 'string',
						isphone: true,
						rule: [
							{ required: true, message: '请输入体重', trigger: 'blur' }
						]
					},
					{
						name: 'breedingType',
						label: '养殖方式',
						type: 'select',
						data: [
							{
								label: '圈养',
								value: '1'
							},
							{
								label: '散养',
								value: '2'
							}
						],
						prop: {
							label: 'label',
							value: 'value'
						},
						isphone: true,
						rule: [
							{ required: true, message: '请选择养殖方式', trigger: 'blur' }
						]
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						isphone: true,
						rule: [
							{ required: true, message: '请输入描述', trigger: 'blur' }
						]
					}
				],
				select: [
					{
						name: 'fenceId',
						data: (value)=>{
							value.splice(0,value.length);
							this.api.Fence.getList()
							.then((response)=>{
								let val=response.data.data.list.map((v)=>{
									return {
										label: v.name,
										value: v.id.toString()
									}
								});
								value.push(...val);
							})
						},
						prop: {
							label: 'label',
							value: 'value'
						}
					},
					{
						name: 'isClaim',
						data: [
							{
								label: '未认领',
								value: '1'
							},
							{
								label: '已认领',
								value: '2'
							}
						],
						prop: {
							label: 'label',
							value: 'value'
						}
					},
					{
						name: 'userId',
						data: (value)=>{
							value.splice(0,value.length);
							this.api.user.getUserList()
							.then((response)=>{
								let val=response.data.data.list.map((v)=>{
									return {
										label: v.username,
										value: v.id.toString()
									}
								});
								value.push(...val);
							})
						},
						prop: {
							label: 'label',
							value: 'value'
						}
					}
				],
				limits: {
					add: true,
					delete: true,
					edit: true,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
